import { render, staticRenderFns } from "./uOttawaVideosDescription.vue?vue&type=template&id=dc7f3e0c&scoped=true&"
import script from "./uOttawaVideosDescription.vue?vue&type=script&lang=ts&"
export * from "./uOttawaVideosDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7f3e0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
